// export const HOST = "https://connectdev.wifichua.co";
//export const HOST = "https://ac-dev-api.wifichua.co";
export const HOST = "https://developer.acheckin.io/api";
// export const HOST = "http://localhost:3000";
